import * as eventRoutines from './eventRoutines';
import produce from 'immer';
const eventsReducer = (state = { activeEfEvent: {}, activeMaster: [], activeMasterFirebase: {} }, action) => {
    switch (action.type) {
        case eventRoutines.fetchEvents.SUCCESS:
            return produce(state, draft => {
                    draft.activeMaster = action.payload;
            });

        case eventRoutines.clearEvents.SUCCESS:
            return produce(state, draft => {
                draft.activeMaster = [];
                draft.activeMasterFirebase = {};
            });

        case eventRoutines.saveEventHeroImage.SUCCESS:
            return produce(state, draft => {
                draft.activeEfEvent = {...state.activeEfEvent, heroImage: action.payload.heroImage}
            });

        case eventRoutines.fetchEvent.SUCCESS:
            return produce(state, draft => {
                draft.activeEfEvent = {...state.activeEfEvent, ...action.payload.data}
            });

        case eventRoutines.fetchActiveMasterEvents.SUCCESS:
            return produce(state, draft => {
                draft.activeMasterFirebase = action.payload ? action.payload : {};
            });

        case eventRoutines.togglePresenceOfEventInActiveEventsList.SUCCESS:
            const { eventAppEnabled, name } = action.payload;
            return produce(state, draft => {
                draft.activeMasterFirebase[action.payload.id] = eventAppEnabled ? name : null;
            });

        case eventRoutines.fetchActiveMasterEventsFirebase.SUCCESS:
            return produce(state, draft => {
                draft.activeMasterFirebase = action.payload ? action.payload : {};
            });

        case eventRoutines.fetchEventInformationFromFB.SUCCESS:
            return produce(state, draft => {
                    draft.activeEfEvent.heroImage = action.payload.imageURL; //Bind image URL from FB data
            });
        default:
            return state;
    }
};
export default eventsReducer;
